import { Avatar, Box } from '@mui/material'
import { ActionButton } from './ActionButton'
import { useEffect, useRef, useState } from 'react'
import { rqx } from '../../../../../../../core/request/API'
import { env } from '../../../../../../../core/Env'
import { Loader } from '../../../../../publication/view/devices/mobile/Loader'
import { SignupForm } from './SignupForm'
import { Comment } from './Comment'
import { timeFormat } from '../../../../../../../core/global/Format'
import DOMPurify from 'dompurify';

export const Index = () => {
    const [itemData, setitemData] = useState(null)
    const [showBottomNav, setShowBottomNav] = useState(true);
    const [isLoader, setisLoader] = useState(false)
    const [flash, setFlash] = useState(false);
    const [showComment, setShowComment] = useState(false)

    const signupRef = useRef(null);
    const location = window.location.pathname
    
    let path = location.split('/')[4]
    const decodePath = atob(path)    
    
    const getData = async () => {
        setisLoader(true)
        const data = await rqx.get(`<<tool>>/${env()}/psl/post/publicationUBR`, { id: decodePath });
        setitemData({...data.publication[0], ...data.counts});            
        setisLoader(false)
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, [decodePath]);

    useEffect(() => {
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY) {
                // Scrolling down
                setShowBottomNav(false);
            } else {
                // Scrolling up
                setShowBottomNav(true);
            }
            
            lastScrollY = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

        // eslint-disable-next-line
    }, []);

    const actionHandler = () => {
        signupRef.current?.scrollIntoView({ behavior: 'smooth' });
        setFlash(true);

        // Stop flashing after 2 seconds
        setTimeout(() => {
            setFlash(false);
        }, 2000);
    };
    
    const clickScreenHandler = () => {
        if (!showBottomNav) {
            setShowBottomNav(true);
        }
    }

    const postedTime = timeFormat(itemData?.published_date);
    const desc = itemData?.description.substring(0, 700) + '...'

    const decodeHTMLEntities = (str) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = str;
        return txt.value;
    }

    const title = decodeHTMLEntities(DOMPurify.sanitize(itemData?.title, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }));

    return (
        <Box width="100%" bgcolor="#FFFFFF">
            {
                isLoader ? 
                <Box height="100vh">
                    <Loader/>
                </Box>
                :
                    itemData !== null ?
                        <Box onClick={() => clickScreenHandler()}>
                            <Box height="100%" bgcolor="#FFFFFF" display="flex" flexDirection="column" p="16px 24px" gap="24px">
                                <Box width="100%" bgcolor="#FFFFFF" display="flex" justifyContent="center" p="16px">
                                    <Box fontSize="12px" fontWeight="600">{location.split('/')[3].toUpperCase()}</Box>
                                </Box>
                                <Box fontSize="20px" lineHeight="138&" fontWeight="700">{title}</Box>
                                <Box display="flex" flexDirection="column" gap="8px">
                                    <Box color="#5B6167" fontSize="12px" >{`Category: ${itemData?.category_name}`}</Box>
                                    <Box color="#5B6167" fontSize="12px" >{`Tax type: ${itemData?.source_name}`}</Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap="12px">
                                    <Avatar src={JSON.parse(itemData?.profile).profile} alt="logo" sx={{height: '40px', width: '40px'}}/>
                                    <Box display="flex" flexDirection="column" >
                                        <Box fontSize="16px" fontWeight="600" >{`${itemData?.first_name} ${itemData?.last_name}`}</Box>
                                        <Box color="#5B6167" fontSize="12px" >{postedTime}</Box>
                                    </Box>
                                </Box>
                                <img src={itemData?.file_link} alt="banner" style={{display: itemData?.file_link === null ? 'none' : 'block' ,height: '200px', width: '100%', borderRadius:'6px', objectFit: 'cover'}}/>
                                <Box position="relative">
                                    <Box
                                        sx={{
                                            height: '115px',
                                            width: '100%',
                                            position: 'absolute',
                                            bottom: 0,
                                            background: 'linear-gradient(rgba(255, 255, 255, 0), rgb(255, 255, 255))'
                                        }}
                                    />
                                    <Box className="story-html" fontSize="14px" color="#5B6167" dangerouslySetInnerHTML={{ __html: desc}}/>
                                </Box>
                            </Box>
                            <SignupForm signupRef={signupRef} flash={flash}/>
                            <ActionButton showBottomNav={showBottomNav} itemData={itemData} actionHandler={actionHandler} setShowComment={setShowComment}  />
                            <Box height="150px"/>
                        </Box>
                    :
                    <Box height="100vh" flexBasis="column">
                            <Box height="100%" display="flex" alignItems="center" justifyContent="center" fontWeight="600">
                                <Box>{`${location.split("/")[3].charAt(0).toUpperCase() + location.split("/")[3].slice(1).toLowerCase()} not found`}</Box>
                            </Box>
                        </Box>
            }
            {showComment && 
                <Comment decodePath={decodePath} showComment={showComment} setShowComment={setShowComment}/>
            }
        </Box>
    )
}
